import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import ElementLocale from 'element-ui/lib/locale'
import elementIdLocale from 'element-ui/lib/locale/lang/id'
import elementViLocale from 'element-ui/lib/locale/lang/vi'
import elementEnLocale from 'element-ui/lib/locale/lang/en'
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'
import elementEsLocale from 'element-ui/lib/locale/lang/es'
import idLocale from './id'
import viLocale from './vi'
import enLocale from './en'
import zhLocale from './zh-CN'
import esLocale from './es-MX'
import thirdCustomer from './third-customer'

Vue.use(VueI18n)

export const languageMessages = {
    id: {
        thirdCustomer: thirdCustomer.id,
        ...idLocale,
        ...elementIdLocale
    },
    vi: {
        thirdCustomer: thirdCustomer.vi,
        ...viLocale,
        ...elementViLocale
    },
    en: {
        thirdCustomer: thirdCustomer.en,
        ...enLocale,
        ...elementEnLocale
    },
    zh: {
        thirdCustomer: thirdCustomer.zh,
        ...zhLocale,
        ...elementZhLocale
    },
    es: {
        thirdCustomer: thirdCustomer.es,
        ...esLocale,
        ...elementEsLocale
    }
}

const i18n = new VueI18n({
    locale: Cookies.get('language') || 'zh',
    messages: languageMessages
})

ElementLocale.i18n((key, value) => i18n.t(key, value))

export default i18n
